import { render, staticRenderFns } from "./ClTableColumns.vue?vue&type=template&id=20d4c153&scoped=true&"
import script from "./ClTableColumns.vue?vue&type=script&lang=js&"
export * from "./ClTableColumns.vue?vue&type=script&lang=js&"
import style0 from "./ClTableColumns.vue?vue&type=style&index=0&id=20d4c153&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4c153",
  null
  
)

export default component.exports